/**
 * Pakiet subskrypcji. Wartości muszą odpowiadać enumowi AppVariant w BE
 * (Kwantum.LegalMail.Data/AppPrivileges.cs): Basic=0, Standard=1, Premium=2.
 */
export enum EAppVariant {
  Free = 0,
  Standard = 1,
  Premium = 2,
}
